<template>
  <NuxtLayout>
    <AccommodationsListing :page="page" kind="hotel" />
  </NuxtLayout>
</template>

<script setup lang="ts">
  defineProps({
    page: {
      type: Object
    }
  });
  
  useHead({
    htmlAttrs: {
      class: 'fixedHeader',
    },
  });
</script>